/* global axios */
import ApiClient from './ApiClient';

class GoogleCalendarAPI extends ApiClient {
  constructor() {
    super('google_calendar', { accountScoped: true });
  }

  getAuthorizeUrl() {
    return axios.get(`${this.url}/authorize_url`);
  }

  callback(code) {
    return axios.post(`${this.url}/callback`, { code });
  }

  disconnect() {
    return axios.post(`${this.url}/disconnect`);
  }

  getStatus() {
    return axios.get(`${this.url}/status`);
  }

  listCalendars() {
    return axios.get(`${this.url}/list_calendars`);
  }

  setDefaultCalendar(calendarId) {
    return axios.post(`${this.url}/set_default_calendar`, {
      calendar_id: calendarId,
    });
  }

  sync() {
    return axios.post(`${this.url}/sync`);
  }

  syncAppointment(appointmentId) {
    return axios.post(`${this.url}/sync_appointment`, {
      appointment_id: appointmentId,
    });
  }
}

export default new GoogleCalendarAPI();
